import { useEffect, useState } from "react";
import { API } from "@/lib/api";

// Fetches a protected image as a blob and renders <img>.
export default function AuthImage({ fileId, className, alt = "photo" }) {
  const [src, setSrc] = useState(null);

  useEffect(() => {
    let url;
    let cancelled = false;
    (async () => {
      try {
        const r = await fetch(`${API}/files/${fileId}`, { credentials: "include" });
        if (!r.ok) return;
        const b = await r.blob();
        url = URL.createObjectURL(b);
        if (!cancelled) setSrc(url);
      } catch {}
    })();
    return () => {
      cancelled = true;
      if (url) URL.revokeObjectURL(url);
    };
  }, [fileId]);

  if (!src) return <div className={`${className} bg-muted animate-pulse`} />;
  return <img src={src} className={className} alt={alt} />;
}
